export const SUPPORT_EMAIL = 'help@collabhouse.com'
export const PRESS_EMAIL = 'info@collabhouse.com'
export const LEGAL_EMAIL = 'legal@collabhouse.com'
export const CLAIMS_EMAIL = 'claims@collabhouse.com'
